import InvoiceHttpService from "../services/http/invoice-http";
import ValidDeliveryDatesResponse from "../shared/interfaces/valid-delivery-dates-response.interface";

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export default async function getMaxAvailabilityDate(invoice: any): Promise<string> {

    const response = await InvoiceHttpService.findDeliveryDate(invoice?.id);

    const datas: ValidDeliveryDatesResponse = response.data;
    
    for (let i = 0; i < datas.deliveryDateSeparationCapacity.length; i+=1) {
        const item = datas.deliveryDateSeparationCapacity[i];
        const date = Date.parse(item.date);
        
        if (
            Date.parse(datas.minDeliveryDate.toString()) + (ONE_DAY_IN_MS * 3) <= date 
            && item.quantity > 0 
            && (date - Date.now()) >=  ONE_DAY_IN_MS * 3
        ) {
            return new Date(date).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        }
    }

    return new Date(Date.parse(response.data.minDeliveryDate)).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}
